import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2, inject } from '@angular/core';

/** Reserve the expanded filter's flow space while its visible card compacts.
 * Shrinking that space can clamp scrollY and retrigger the sticky boundary.
 */
@Directive({ selector: '[appStableStickyFilter]', standalone: true })
export class StableStickyFilterDirective implements AfterViewInit, OnDestroy {
    private element = inject(ElementRef<HTMLElement>);
    private renderer = inject(Renderer2);
    private expandedHeight = 0;
    private compact = false;
    private resizeObserver?: ResizeObserver;

    @Input()
    set appStableStickyFilter(compact: boolean) {
        if (!this.compact) this.measureExpandedHeight();
        this.compact = compact;
        if (compact && this.expandedHeight > 0) {
            this.renderer.setStyle(this.element.nativeElement, 'min-height', `${this.expandedHeight}px`);
        } else {
            this.renderer.removeStyle(this.element.nativeElement, 'min-height');
        }
    }

    ngAfterViewInit(): void {
        this.measureExpandedHeight();
        const card = this.element.nativeElement.firstElementChild;
        if (card && typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(() => {
                if (!this.compact) this.measureExpandedHeight();
            });
            this.resizeObserver.observe(card);
        }
    }

    ngOnDestroy(): void {
        this.resizeObserver?.disconnect();
    }

    private measureExpandedHeight(): void {
        const card = this.element.nativeElement.firstElementChild;
        if (!card) return;
        // Advanced filters expand by explicit user action; reserve only the bar,
        // so closing that panel does not leave its entire height as empty space.
        const body = card.firstElementChild;
        const style = getComputedStyle(card);
        this.expandedHeight = (body || card).getBoundingClientRect().height
            + (body ? parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) : 0);
    }
}
